<template>
  <div class="search-wrapper">
    <search-comp
      @onSearch="$emit('search', searchParams)"
      @onReset="
        searchParams = { ...defaultSearchParams }
        $emit('search', defaultSearchParams)
      "
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div
                class="das-form-input"
                title="Tìm kiếm theo mã hồ sơ, tên cty/đại lý du lịch, tên cty trên hóa đơn"
              >
                <div class="label">
                  {{ $t('config.profile.searchBox.info') }}
                </div>
                <div class="child-w-80">
                  <input
                    v-model="searchParams.customerInfo"
                    type="text"
                    placeholder="Nhập mã/tên công ty/đại lý"
                  />
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ $t('config.profile.searchBox.source') }}
                </div>
                <div class="child-w-80">
                  <!-- <input type="text"> -->
                  <select-with-search-table
                    style="width: 100%"
                    :search-fields="['desc', 'code']"
                    index-field="id"
                    :selected-index-field-value="searchParams.sourceId"
                    :rows="sourceRows"
                    :columns="sourceCols"
                    :value="searchParams.sourceId"
                    :dropdown-width="400"
                    :is-remove-btn="true"
                    @selectionChanged="onSelectSource"
                  >
                    <template v-slot:value="{ selectedValue: selectedData }">
                      <div>
                        <span>
                          {{
                            `${selectedData?.id || ''} - ${
                              selectedData?.code || ''
                            }`
                          }}
                        </span>
                      </div>
                    </template>
                  </select-with-search-table>
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ $t('config.profile.searchBox.businessManName') }}
                </div>
                <div class="child-w-80">
                  <!-- <input type="text" /> -->
                  <select-with-search-table
                    style="width: 100%"
                    :search-fields="['id', 'full_name']"
                    index-field="id"
                    :selected-index-field-value="searchParams.salesPerson"
                    :value="searchParams.salesPerson"
                    :rows="businessManRows"
                    :columns="businessManCols"
                    :dropdown-width="400"
                    :is-remove-btn="true"
                    @selectionChanged="onSelectBusinessMan"
                  >
                    <template v-slot:value="{ selectedValue: selectedData }">
                      <div>
                        <span>
                          {{ selectedData?.full_name }}
                        </span>
                      </div>
                    </template>
                  </select-with-search-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
  </div>
</template>

<script>
import { getAllBusinessMan, getAllSource } from '../../commonApiCall'
export default {
  // props: {
  //   value: {
  //     type: Object,
  //     default: () => ({
  //       customerInfo: null,
  //       sourceId: null // number
  //     })
  //   }
  // },
  data: function () {
    return {
      searchShow: true,

      searchParams: {
        customerInfo: null,
        sourceId: null, // number
        salesPerson: null // id - number
      },
      defaultSearchParams: {
        customerInfo: null,
        sourceId: null, // number
        salesPerson: null // id - number
      },

      // profile type
      // col for display

      // row for data
      // profileTpRows: [
      //   { code: 1, name: 'Công ty', desc: '' },
      //   { code: 2, name: 'Đại lý du lịch', desc: '' }
      // ],
      sourceRows: [],
      businessManRows: []
    }
  },

  computed: {
    sourceCols() {
      return [
        {
          headerName: this.$t('config.profile.select.sourceCode'),
          field: 'code',
          tooltipField: 'code'
        },
        {
          headerName: this.$t('config.profile.select.description'),
          field: 'desc',
          tooltipField: 'desc'
        }
      ]
    },
    // profileTpCols() {
    //   return [
    //     // { headerName: 'Mã', field: 'code', tooltipField: 'code' },
    //     {
    //       headerName: this.$t('config.profile.select.sourceId'),
    //       field: 'name',
    //       tooltipField: 'name'
    //     }
    //     // { headerName: 'Mô tả', field: 'desc', tooltipField: 'desc' }
    //   ]
    // },
    businessManCols() {
      return [
        {
          headerName: this.$t('config.profile.select.businessManCode'),
          field: 'id',
          tooltipField: 'id'
        },
        {
          headerName: this.$t('config.profile.select.businessManName'),
          field: 'full_name',
          tooltipField: 'full_name'
        }
      ]
    }
  },

  async mounted() {
    this.businessManRows = await getAllBusinessMan()
    this.sourceRows = await getAllSource()
  },

  methods: {
    onSelectBusinessMan(data) {
      this.searchParams.salesPerson = data?.id || null
    },
    onSelectSource(data) {
      this.searchParams.sourceId = data?.id || null
    }
  }
}
</script>

<style lang="scss" scoped></style>
